exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wp_points[data-v-49d8a8df]{line-height:21px;border-radius:.625rem;display:-webkit-box;display:-ms-flexbox;display:flex;font-weight:700;height:20px}.wp_points_bg[data-v-49d8a8df]{background:rgba(0,0,0,.34)}.wp_points .money_icon[data-v-49d8a8df]{width:20px;height:20px;border-radius:.625rem}.wp_points .icon_span[data-v-49d8a8df]{border-radius:.625rem}.wp_points .points_text[data-v-49d8a8df]{text-align:left;padding-left:5px;padding-right:5px;min-width:20px}", ""]);

// exports
